import React from 'react';

const policySections = [
  {
    title: 'Introduction',
    body: `At Fit-Mate24, we respect your right to control your personal data. This policy explains how you can request account deletion, what happens to your data, and other important details.`,
  },
  {
    title: '1. How to Request Account Deletion',
    body: `Users can request account deletion through the following methods:\n• Emailing support@fit-mate24.com with your request.\n• Submitting a request via the Settings > Account > Delete Account feature in the app.\nPlease include your registered email address or username. Once verified, the deletion process will be initiated.`,
  },
  {
    title: '2. What Happens When You Delete Your Account?',
    body: `Your personal information (name, email, profile data) will be permanently deleted from our systems, except where retention is required by law. This includes all account activity, settings, and app usage data. Some anonymized aggregate data may be retained for analytical purposes, which cannot be linked to your identity.`,
  },
  {
    title: '3. Processing Time',
    body: `Account deletions are typically processed within 14 days after the request is verified. You will receive a confirmation email once deletion is complete.`,
  },
  {
    title: '4. Non-Refundable Payments',
    body: `Payments for subscriptions or in-app purchases are non-refundable after initiating the deletion process, as stated in our Terms and Conditions.`,
  },
  {
    title: '5. Exceptions or Limitations',
    body: `There are limited exceptions where we may retain certain data, such as:\n• To comply with legal obligations\n• For the establishment, exercise, or defense of legal claims\nSuch data will be securely stored and only accessible to authorized personnel.`,
  },
  {
    title: '6. Data Retention Policy',
    body: `Some personal data may be retained as required by statutory obligations (e.g., for tax or legal compliance) even after account deletion.`,
  },
  {
    title: '7. Reinstating a Deleted Account',
    body: `Once your account is deleted, it cannot be reinstated. If you wish to use our services again, you will need to register as a new user with a new account.`,
  },
  {
    title: '8. Contact & Support',
    body: `For additional questions or concerns about deleting your Fit-Mate24 account, please contact our support team at support@fit-mate24.com or see our Help Center for additional information.`,
  },
];

const pageStyle = {
  minHeight: '100vh',
  // width: '100vw',
  margin: 0,
  overflowX: 'hidden', // prevent horizontal scroll on body
  display: 'flex',
  justifyContent: 'center',
  boxSizing: 'border-box',
  fontFamily: 'Californian FB, serif',

};

const cardStyle = {
  background: '#18181a',
  color: 'white',
  boxShadow: '0 5px 24px #000a',
  fontFamily: 'Californian FB, serif',
  padding: 24,
  // maxWidth: 600,       // limit max width to avoid overflow
  width: '100%', // responsive width
  overflowWrap: 'break-word', // break long words/links
  wordWrap: 'break-word', // fallback
  boxSizing: 'border-box',
};

const headerStyle = {
  fontSize: 28,
  fontWeight: 600,
  fontFamily: 'serif',
  marginBottom: 14,
  textAlign: 'center',
};

const dateStyle = {
  fontSize: 12,
  marginBottom: 20,
  color: '#bbb',
  textAlign: 'center',
};

export default function DeleteAccountPolicy() {
  return (
    <div style={pageStyle}>
      <div style={cardStyle}>
        <div
          style={{
            fontWeight: 700,
            marginBottom: 16,
            fontSize: 15,
          }}>
          fit-mate24
        </div>
        <div style={headerStyle}>
          Delete User
          <br />
          Account Policy
        </div>
        <div style={dateStyle}>Effective Date: 01 January 2023</div>
        {policySections.map((section, idx) => (
          <div key={idx} style={{ marginBottom: 20 }}>
            <strong>{section.title}</strong>
            <div style={{ fontSize: 15, marginTop: 5, whiteSpace: 'pre-line' }}>{section.body}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
